import type { DocumentReferencesView, FirmDocumentReference } from 'api';
import { formatDate, shortDate } from 'utilities';

type FirmDocumentMetadataReference = DocumentReferencesView & Pick<
  Partial<FirmDocumentReference>,
  'requested_files' | 'source'
>;

const REFERENCE_OBJECT_TYPE_LABELS: Record<string, string> = {
  ct: 'Cap Table',
  fi: 'Financials',
  fo: 'Fund Ownership',
};

export const getFirmDocumentUploadedDateLabel = (date?: string | null) => {
  if (!date) {
    return null;
  }

  return shortDate(date) ?? formatDate({ date });
};

export const getFirmDocumentUploadedByLabel = (documentReference: FirmDocumentMetadataReference) => {
  const uploadedBy = documentReference.file.uploaded_by;

  return uploadedBy?.full_name?.trim() || uploadedBy?.email || documentReference.source?.label || null;
};

export const getFirmDocumentReferenceLabels = (documentReference: FirmDocumentMetadataReference) => (
  documentReference.referenced_in
    ?.map(reference => (
      reference.reference_object_type
        ? REFERENCE_OBJECT_TYPE_LABELS[reference.reference_object_type] ?? reference.reference_object_type
        : null
    ))
    .filter((referenceLabel): referenceLabel is string => Boolean(referenceLabel))
    ?? []
);

export const getFirmDocumentRequestedFileLabels = (documentReference: FirmDocumentMetadataReference) => (
  documentReference.requested_files?.map(requestedFile => requestedFile.name) ?? []
);
